/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Network_Inspector_EmptyInputs */

const en_mobile_network_inspector_empty = /** @type {(inputs: Mobile_Network_Inspector_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No network requests captured yet.`)
};

const es_mobile_network_inspector_empty = /** @type {(inputs: Mobile_Network_Inspector_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se capturaron solicitudes de red.`)
};

/**
* | output |
* | --- |
* | "No network requests captured yet." |
*
* @param {Mobile_Network_Inspector_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_network_inspector_empty = /** @type {((inputs?: Mobile_Network_Inspector_EmptyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Network_Inspector_EmptyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_network_inspector_empty(inputs)
	return en_mobile_network_inspector_empty(inputs)
});